<script lang="ts" setup>
// ----------------------------------
// Hooks
// ----------------------------------
const { $service } = useNuxtApp();
const router = useRouter();

// ----------------------------------
// Methods
// ----------------------------------

function handlerError(err: any) {
  if (err?.response?.status === 401) {
    router.push('/sign_in');
  }
}

// ----------------------------------
// Lifecycle
// ----------------------------------
onBeforeMount(async () => {
  console.info('Looping...');
  await $service.auth.load();

  $service
    .user
    .info()
    .catch(handlerError);
});

</script>
<template>
  <div class="w-full h-full flex justify-items-center">
    <UContainer>
      <span>
        Loading...
      </span>
    </UContainer>
  </div>
</template>
<style lang="scss" scoped>
footer {
  img {
    display: block;
    margin: 0 auto;
    width: 160px;
  }
}

content img {
  width: 140px;
}
</style>